<template>
    <v-container style="max-width:100vw;">
        <v-toolbar class="px-6 py-4 mb-4" style="background:transparent;" flat>
            <v-toolbar-title>{{ header }}</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-row class="notes-columns">
            <v-col cols="12" md="6">
                <notes-column
                    title="Para ti"
                    :notes="notesToMe"
                    :total="toMe.total"
                    :loading="toMe.loading"
                    :page="toMe.page"
                    :last-page="toMe.lastPage"
                    :filters="toMe.filters"
                    :company="company"
                    :current-user-id="currentUser.id"
                    :allow-read-actions="true"
                    :allow-edit="false"
                    :allow-delete="false"
                    :hide-to-user="true"
                    @apply-filters="applyFilters('to', $event)"
                    @load-more="loadMore('to')"
                    @mark-read="markRead"
                    @mark-done="markDone"
                />
            </v-col>
            <v-col cols="12" md="6">
                <notes-column
                    title="Tus notas"
                    :notes="notesFromMe"
                    :total="fromMe.total"
                    :loading="fromMe.loading"
                    :page="fromMe.page"
                    :last-page="fromMe.lastPage"
                    :filters="fromMe.filters"
                    :company="company"
                    :current-user-id="currentUser.id"
                    :allow-read-actions="false"
                    :allow-edit="canEdit"
                    :allow-delete="canDelete"
                    :hide-from-user="true"
                    @apply-filters="applyFilters('from', $event)"
                    @load-more="loadMore('from')"
                    @edit="openEdit"
                    @delete="deleteItem"
                />
            </v-col>
        </v-row>

        <v-dialog v-model="createDialog" max-width="750px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn bottom color="#e25200" dark fab fixed right v-bind="attrs" v-on="on">
                <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
          </template>
          <create v-bind:company="company" @closeCreateDialogNote="closeCreateDialogNote"/>
        </v-dialog>

        <v-dialog v-model="editDialog" max-width="750px">
          <edit-note :note-data="editNote" @closeEditDialogNote="closeEditDialogNote" />
        </v-dialog>

        <div class="text-center">
            <v-bottom-sheet v-model="sheet" inset>
                <v-sheet class="text-center" height="150px">
                    <div class="pt-6">
                    Seguro que deseas borrar esta nota?
                    </div>
                    <v-btn class="mt-4" text color="error" @click="deleteNote()">
                    Eliminar
                    </v-btn>
                    <v-btn class="mt-4" text color="grey" @click="cancel()">
                    Cancelar
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>
        </div>

        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-container>
</template>

<script>
  import axios from "axios";
  import NotesColumn from "../notes/NotesColumn"
  import Create from "../notes/create"
  import EditNote from "../notes/edit"

  const defaultFilters = () => ({
    company_id: [],
    contact_id: [],
    from_user_id: [],
    to_user_id: [],
    dateFrom: '',
    dateTo: '',
    seenPending: true,
    seenRead: true,
    seenDone: false,
  })

  export default {
    props:{
      company:[String, Object]
    },
    components: {
      'notes-column': NotesColumn,
      'create': Create,
      'edit-note': EditNote,
    },
    data: () => ({
      snackbar: {
          show: false,
          message: null,
          color: null
      },
      createDialog:false,
      editDialog:false,
      editNote:null,
      deleteId:'',
      sheet:false,
      perPage: 15,
      notesToMe: [],
      notesFromMe: [],
      toMe: {
        page: 1,
        lastPage: 1,
        total: 0,
        loading: false,
        filters: defaultFilters(),
      },
      fromMe: {
        page: 1,
        lastPage: 1,
        total: 0,
        loading: false,
        filters: defaultFilters(),
      },
    }),
    computed:{
      currentUser:{
        get(){
          return this.$store.state.currentUser.user
        }
      },
      header(){
        return 'Notas'
      },
      canDelete(){
        return this.permissions('deleteNotes') || this.currentUser.id == 1
      },
      canEdit(){
        return this.permissions('editNotes') || this.currentUser.id == 1
      },
    },
    created(){
      if(this.currentUser && this.currentUser.id){
        this.refreshNotes()
      }
    },
    watch:{
      'currentUser.id': function(value){
        if(value){
          this.refreshNotes()
        }
      },
      company:{
        handler(){
          this.refreshNotes()
        },
        deep: true
      }
    },
    methods:{
      permissions(permission){
        if(this.currentUser.id==1){
          return true
        }else if(this.currentUser.permissions!=undefined){
          if(this.currentUser.permissions.includes(permission)){
            return true
          }else{
            return false
          }
        }else{
          return false
        }
      },
      refreshNotes(){
        this.toMe.page = 1
        this.fromMe.page = 1
        this.fetchNotes('to', true)
        this.fetchNotes('from', true)
      },
      applyFilters(direction, filters){
        if(direction === 'to'){
          this.toMe.filters = filters
          this.toMe.page = 1
        }else{
          this.fromMe.filters = filters
          this.fromMe.page = 1
        }
        this.fetchNotes(direction, true)
      },
      loadMore(direction){
        if(direction === 'to'){
          if(this.toMe.page >= this.toMe.lastPage){
            return
          }
          this.toMe.page += 1
          this.fetchNotes('to', false)
        }else{
          if(this.fromMe.page >= this.fromMe.lastPage){
            return
          }
          this.fromMe.page += 1
          this.fetchNotes('from', false)
        }
      },
      resolveCompanyId(company){
        if(company && typeof company === 'object'){
          return company.id
        }
        if(company !== '' && company !== null && company !== undefined){
          return Number(company)
        }
        return null
      },
      normalizeSeen(value){
        if(value === null || value === undefined){
          return 'Pendiente'
        }
        const normalized = String(value).trim().toLowerCase()
        if(normalized === 'pendiente' || normalized === 'null'){
          return 'Pendiente'
        }
        if(normalized === 'leido'){
          return 'Leido'
        }
        if(value === false || value === 0 || value === '0'){
          return 'Leido'
        }
        if(normalized === 'realizado'){
          return 'Realizado'
        }
        if(value === true || value === 1 || value === '1'){
          return 'Realizado'
        }
        return 'Pendiente'
      },
      buildSeenFilter(filters){
        const selected = []
        if(filters.seenPending){
          selected.push('Pendiente')
        }
        if(filters.seenRead){
          selected.push('Leido')
        }
        if(filters.seenDone){
          selected.push('Realizado')
        }
        if(selected.length === 0){
          return { none: true }
        }
        if(selected.length === 3){
          return { value: null }
        }
        return { value: selected.join(',') }
      },
      buildParams(direction){
        const params = {
          page: direction === 'to' ? this.toMe.page : this.fromMe.page,
          itemsPerPage: this.perPage,
        }
        if(direction === 'to'){
          params['filter[to_user_id]'] = this.currentUser.id
        }else{
          params['filter[from_user_id]'] = this.currentUser.id
        }

        const filters = direction === 'to' ? this.toMe.filters : this.fromMe.filters
        const seenFilter = this.buildSeenFilter(filters)
        if(seenFilter.none){
          return { params, empty: true }
        }
        if(seenFilter.value){
          params['filter[seen]'] = seenFilter.value
        }

        if(filters.company_id && filters.company_id.length){
          params['filter[company_id]'] = filters.company_id.join(',')
        }
        if(filters.contact_id && filters.contact_id.length){
          params['filter[contact_id]'] = filters.contact_id.join(',')
        }
        if(direction === 'to' && filters.from_user_id && filters.from_user_id.length){
          params['filter[from_user_id]'] = filters.from_user_id.join(',')
        }
        if(direction === 'from' && filters.to_user_id && filters.to_user_id.length){
          params['filter[to_user_id]'] = filters.to_user_id.join(',')
        }
        if(filters.dateFrom || filters.dateTo){
          const from = filters.dateFrom || filters.dateTo
          const to = filters.dateTo || filters.dateFrom
          params['filter[created_between]'] = from + ',' + to
        }
        const companyId = this.resolveCompanyId(this.company)
        if(companyId){
          params['filter[company_id]'] = companyId
        }
        return { params, empty: false }
      },
      fetchNotes(direction, reset){
        console.log(1)
        if(direction === 'to'){
          console.log(1.1)
          if(this.toMe.loading){
            console.log('1.1.1')
            return
          }
          console.log('1.1.2')
          this.toMe.loading = true
        }else{
          console.log(1.2)
          if(this.fromMe.loading){
            console.log('1.2.1')
            return
          }
          console.log('1.2.2')
          this.fromMe.loading = true
        }
        console.log('2')

        const built = this.buildParams(direction)
        if(built.empty){
          console.log('2.1')
          if(direction === 'to'){
            console.log('2.1.1')
            this.notesToMe = []
            this.toMe.total = 0
            this.toMe.loading = false
          }else{
            console.log('2.1.2')
            this.notesFromMe = []
            this.fromMe.total = 0
            this.fromMe.loading = false
          }
          console.log('2.1.3')
          //return
        }

        console.log('3')

        axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/notes", { params: built.params }).then(response => {
          const data = response.data || {}
          const items = data.data || []
          const meta = data.meta || {}
          if(direction === 'to'){
            this.toMe.lastPage = meta.last_page || 1
            this.toMe.total = meta.total || items.length
            this.notesToMe = reset ? items : this.notesToMe.concat(items)
          }else{
            this.fromMe.lastPage = meta.last_page || 1
            this.fromMe.total = meta.total || items.length
            this.notesFromMe = reset ? items : this.notesFromMe.concat(items)
          }
        }).catch(error => {
          this.snackbar = {
            message: error.response && error.response.data ? error.response.data.message : 'Error al cargar notas',
            color: 'error',
            show: true
          }
        }).finally(() => {
          if(direction === 'to'){
            this.toMe.loading = false
          }else{
            this.fromMe.loading = false
          }
        })
      },
      markRead(note){
        if(this.normalizeSeen(note.seen) !== 'Pendiente'){
          return
        }
        this.updateSeen(note, 'Leido')
      },
      markDone(note){
        if(this.normalizeSeen(note.seen) !== 'Leido'){
          return
        }
        this.updateSeen(note, 'Realizado')
      },
      buildPayload(note, overrides = {}){
        return Object.assign({
          company_id: note.company ? note.company.id : null,
          contact_id: note.contact ? note.contact.id : null,
          from_user_id: note.from_user ? note.from_user.id : null,
          to_user_id: note.to_user ? note.to_user.id : null,
          comment: note.comment,
          seen: note.seen,
        }, overrides)
      },
      updateSeen(note, value){
        const payload = this.buildPayload(note, { seen: value })
        axios.patch(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/notes/" + note.id, payload).then(() => {
          note.seen = value
          this.fetchNotes('to', true)
          this.refreshBadgeCount()
        }).catch(error => {
          this.snackbar = {
            message: error.response && error.response.data ? error.response.data.message : 'Error al actualizar la nota',
            color: 'error',
            show: true
          }
        })
      },
      deleteNote(){
        axios.delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/notes/" + this.deleteId).then(() => {
          this.deleteId = ''
          this.sheet = false
          this.fetchNotes('from', true)
          this.refreshBadgeCount()
        }).catch(error => {
          this.snackbar = {
            message: error.response && error.response.data ? error.response.data.message : 'Error al eliminar la nota',
            color: 'error',
            show: true
          }
        })
      },
      cancel(){
        this.deleteId = ''
        this.sheet = false
      },
      deleteItem(note){
        if(!this.canDelete){
          return
        }
        if(!note || !note.id){
          return
        }
        if(note.from_user && String(note.from_user.id) !== String(this.currentUser.id) && this.currentUser.id != 1){
          return
        }
        this.deleteId = note.id
        this.sheet = true
      },
      openEdit(note){
        if(!this.canEdit){
          return
        }
        if(note && note.from_user && String(note.from_user.id) !== String(this.currentUser.id) && this.currentUser.id != 1){
          return
        }
        this.editNote = [note].map(n=>{return{
          id: n.id,
          company_id: n.company_id || n.company?.id,
          contact_id: n.contact_id || n.contact?.id,
          from_user_id: n.from_user_id || n.from_user?.id,
          to_user_id: n.to_user_id || n.to_user?.id,
          comment:n.comment,
          seen:n.seen,
          company: n.company,
          contact: n.contact,
          from_user: n.from_user,
          to_user: n.to_user,
        }})[0]
        this.editDialog = true
      },
      closeCreateDialogNote: function(params) {
        this.createDialog = false
        this.fetchNotes('from', true)
        this.refreshBadgeCount()
      },
      closeEditDialogNote: function(params) {
        this.editDialog = false
        this.editNote = null
        this.fetchNotes('from', true)
        this.fetchNotes('to', true)
        this.refreshBadgeCount()
      },
      refreshBadgeCount(){
        if(!this.currentUser || !this.currentUser.id){
          return
        }
        const params = {
          itemsPerPage: 1,
          'filter[to_user_id]': this.currentUser.id,
          'filter[seen]': 'Pendiente'
        }
        this.$store.dispatch('notes/getNotes', params)
      },
    },
  }
</script>

<style>
  .notes-columns{
    padding: 0 12px 24px;
  }
</style>
